import gql from 'graphql-tag'

export const INSERT_APPLICATIONS = gql`
mutation insert_Applications($id:uuid,$partnerType:uuid, $stageId:uuid, $name:String!,
 $userName:String!,$address:jsonb!, $mobile:String!,$alternateNumber:String!, $email:String!,$incorporateDate:date,$userBirthdate:date,$userAniversary:date, $gstin:String, $aadhaarNumber:String, $PAN:String,
  $bankDetails:jsonb!, $parentPartnerId:uuid!, $prefferedDistributors:jsonb!,  $referralCode:String!, $userId:uuid!){
  insert_Applications(objects: {id:$id, partnerType:$partnerType,stageId:$stageId,name:$name, userName:$userName,
   address:$address, mobile:$mobile,alternateNumber:$alternateNumber, email:$email,incorporateDate:$incorporateDate,userBirthdate: $userBirthdate,userAniversary:$userAniversary,gstin:$gstin, aadhaarNumber:$aadhaarNumber, PAN:$PAN, bankDetails:$bankDetails,
   referralCode:$referralCode, parentPartnerId:$parentPartnerId, prefferedDistributors:$prefferedDistributors,createdBy:$userId,updatedBy:$userId})
  {returning{
  id
  
  }}
  }
`

export const UPDATE_PARTNER_INSERT_APPLICATION_COMMENTS = gql`
 mutation ($id: uuid!, $comment: String!, $applicationId: uuid!, $stageId: uuid!,$userId:uuid!, $skipInsert: Boolean!) {
  insert_ApplicationComments(objects: {id: $id, comment: $comment, applicationId: $applicationId})  @skip(if: $skipInsert){
    returning {
      id 
 }
}
update_Applications (
    where: {id: {_eq: $applicationId}}
    _set: {stageId: $stageId,updatedBy:$userId}
  ) {
    returning {
      id
     }
    } 
  }
`
export const UPDATE_PARTNER = gql`
mutation update_Applications($id:uuid!,$name:String!,$partnerType:uuid,
 $userName:String!,$address:jsonb!, $mobile:String!,$alternateNumber:String!, $email:String!,$incorporateDate:date!,$userBirthdate:date!,$userAniversary:date!, $gstin:String!, $PAN:String,
  $bankDetails:jsonb!) {
update_Applications(where:{id:{_eq:$id}}, _set:{name:$name, partnerType:$partnerType, userName:$userName,address:$address,mobile:$mobile, alternateNumber:$alternateNumber,
  email:$email, incorporateDate:$incorporateDate, userBirthdate:$userBirthdate, userAniversary:$userAniversary, gstin:$gstin, PAN:$PAN,bankDetails:$bankDetails}){
  returning{
  id
  }}
}
`


// export const UPDATE_PARTNER = gql`
// mutation update_Applications($id:uuid!,$name:String!,$partnerType:uuid,
//  $userName:String!,$address:String!, $mobile:bigint!,$alternateNumber:bigint!, $email:String!,$incorporateDate:date!,$userBirthdate:date!,$userAniversary:date!, $gstin:String!, $PAN:String!,
//   $bankDetails:jsonb!, $parentPartnerId:uuid!, $referralCode:String!) {
// update_Applications(where:{id:{_eq:$id}}, _set:{name:$name, partnerType:$partnerType, userName:$userName,address:$address,mobile:$mobile, alternateNumber:$alternateNumber,
//   email:$email, incorporateDate:$incorporateDate, userBirthdate:$userBirthdate, userAniversary:$userAniversary, gstin:$gstin, PAN:$PAN,bankDetails:$bankDetails, parentPartnerId:$parentPartnerId,referralCode:$referralCode
// }){
//   returning{
//   id
//   }}
// }
// `
export const UPDATE_APPLICATION_STAGE=gql`
mutation update_Applications($id:uuid!,$stageId:uuid!,$updatedBy:uuid!){
update_Applications(where:{id:{_eq:$id}},_set:{stageId:$stageId,updatedBy:$updatedBy}){
returning{id}}
}
`
